/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let rListUsersApiUrl = root.rListUsersApiUrl.link;
import Vue from 'vue'
export default {
  state: {
    getRListUsersState:{},
  },
  mutations: {
    getRListUsersMutation(state, value) {
      Vue.set(state, 'getRListUsersState', value);
    },
  },
  actions: {
    // Get  R LIst Action
    getRListUsersFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(rListUsersApiUrl, payload).then(res => {
              context.commit('getRListUsersMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get  R LIst Action
    getRListUserListDetailsById(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(rListUsersApiUrl + payload.id + '/', payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create  L LIst User Info
    addNewRListUserFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(rListUsersApiUrl,payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update L LIst User Info
    UpdateRListUserDetailsById(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(rListUsersApiUrl + payload.data.id + '/', payload.data.data ).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Delete  L List User Info
    removeRListUserFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(rListUsersApiUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getRListUsersGetters: state => state.getRListUsersState,
  }
}